import { extensionOf, HEIF_EXTENSIONS } from '@/components/imageIntake/heicFiles';

const EMBEDDABLE_IMAGE_EXTENSIONS = ['.gif', '.jpeg', '.jpg', '.png'];
const SEARCH_IMAGE_EXTENSIONS = [...EMBEDDABLE_IMAGE_EXTENSIONS, ...HEIF_EXTENSIONS];

export const MAX_SEARCH_IMAGES = 10;
export const ALLOWED_IMAGE_FORMATS = SEARCH_IMAGE_EXTENSIONS.join(',');
export const UNSUPPORTED_SEARCH_IMAGE_MESSAGE = 'Only GIF, JPEG, PNG, or HEIC images can be searched.';

export const isSearchImage = (file: File): boolean => SEARCH_IMAGE_EXTENSIONS.includes(extensionOf(file));
